if (!customElements.get('seed-product-sizes')) {
  customElements.define('seed-product-sizes', class SeedProductSizes extends HTMLElement {
    constructor() {
      super();
      this.relatedSizes = this.querySelectorAll('[js-related-sizes]');
      this.relatedSizeTitle = this.querySelector('[js-related-size-title]');
    }

    connectedCallback() {
      this._initRelatedSizes();
      console.log('connectedCallback')
    }

    async _initRelatedSizes() {
      console.log('initRelatedSizes')
      this.relatedSizesContainer = this.relatedSizes;
      if (this.relatedSizesContainer.length < 1) {
        return;
      }
  
      const currentProductHandle = this.relatedSizesContainer[0].getAttribute('data-handle');
      const relatedSizesTag = this.relatedSizesContainer[0].getAttribute('data-tag');
      const standardSizeText = this.relatedSizesContainer[0].getAttribute('data-standard-text');
      const plusSizeText = this.relatedSizesContainer[0].getAttribute('data-plus-text');
      const targetURL = `/collections/all-products/${relatedSizesTag}/?view=json`;
      const relatedSizesJSON = await this._getRelatedSizeJSON(targetURL);
      let relatedSizesMarkup = '';
  
      if (relatedSizesJSON.length <= 1) {
        return;
      }

      // Find one standard and one plus product. Deduplicates when multiple variants exist.
      const plusProduct = relatedSizesJSON.find((product) => product.handle.includes('plus-size'));
      const standardProduct = relatedSizesJSON.find((product) => !product.handle.includes('plus-size'));
      const isCurrentPlus = currentProductHandle.includes('plus-size');

      if (standardProduct) {
        const isActive = !isCurrentPlus;
        const standardClasses = isActive
          ? 'product-related-sizes link size-btn-disabled active-size'
          : 'product-related-sizes link size-btn';
        relatedSizesMarkup += `<a href="${standardProduct.url}" class="${standardClasses}" aria-label="${standardSizeText}">${standardSizeText}</a>`;
      }
      if (plusProduct) {
        const isActive = isCurrentPlus;
        const plusClasses = isActive
          ? 'product-related-sizes link size-btn-disabled active-size'
          : 'product-related-sizes link size-btn';
        relatedSizesMarkup += `<a href="${plusProduct.url}" class="${plusClasses}" aria-label="${plusSizeText}">${plusSizeText}</a>`;
      }
  
      this.relatedSizeTitle?.classList.remove('hidden');
      this.relatedSizesContainer.forEach(container => {
        container.innerHTML = relatedSizesMarkup;
        container.classList.remove('hidden');
      })
    }
  
    _getRelatedSizeJSON(url) {
      console.log('getRelatedSizeJSON')
      return fetch(url)
        .then(response => response.text())
        .then((text) => {
          const html = text;
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
          const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
          const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
          return parsedJSON;
        })
    }
  }
)};
